import Keycloak from 'keycloak-js';
import { config } from '../config';

const instances = new Map();
const initPromises = new Map();

export function getKeycloak(clientId) {
  if (!instances.has(clientId)) {
    instances.set(
      clientId,
      new Keycloak({
        url: config.keycloakUrl,
        realm: config.keycloakRealm,
        clientId,
      }),
    );
  }
  return instances.get(clientId);
}

export function initKeycloak(clientId) {
  if (!initPromises.has(clientId)) {
    const keycloak = getKeycloak(clientId);
    const promise = keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
      })
      .catch((err) => {
        initPromises.delete(clientId);
        throw err;
      });
    initPromises.set(clientId, promise);
  }
  return initPromises.get(clientId);
}
